import { render } from "./PrimeFinding.vue?vue&type=template&id=7e88e9a6&scoped=true"
import script from "./PrimeFinding.vue?vue&type=script&lang=js"
export * from "./PrimeFinding.vue?vue&type=script&lang=js"

import "./PrimeFinding.vue?vue&type=style&index=0&id=7e88e9a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e88e9a6"]])

export default __exports__